import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Auth0ProviderWithHistory from './auth/auth0-provider-with-history';
// curated brand fonts (item 35) — keep in sync with ALLOWED_FONTS
// item 1516 — only the STOCK face ships eagerly; Montserrat / Raleway / Lato / Inter load on
// demand from their own chunks (theme/lazyFonts.ts: BrandThemeProvider when a tenant's brand
// resolves to one, the Branding font picker when it mounts).
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';
// item 852 — the RNWY kit (Proposal Portal brand defaults)
import '@fontsource/albert-sans/400.css';
import '@fontsource/albert-sans/700.css';
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/700.css';
// item 61 — Accountant LEDGER skin: a true typewriter monospace
import '@fontsource/courier-prime/400.css';
import '@fontsource/courier-prime/700.css';

// Perf: local dev talks to the AZURE DB over the internet, so every query is a WAN
// round-trip. react-query's defaults (staleTime 0 + refetch on every mount AND window
// focus) turned each navigation / tab-refocus into a storm of simultaneous refetches
// (the accountant dashboard alone fires ~10 queries), which made the app crawl. These
// defaults keep data fresh for 30s and stop the refetch-everything-on-focus storm.
// Mutations still call queryClient.invalidateQueries(...), which force-refreshes the
// affected queries regardless of staleTime — so post-action data stays correct.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Router>
      <Auth0ProviderWithHistory>
        <App />
      </Auth0ProviderWithHistory>
    </Router>
  </QueryClientProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
